var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'single-learningpath-item-path',
{   'last': _vm.isLastItem,
    'halfWatched': _vm.isCourseHalfWatched,
    'completed': _vm.isCourseCompleted,
    'not-logged': !_vm.isLoggedIn,
    'paragraph': _vm.isParagraphInBetweenCourses,
    'mobile': _vm.isMobileView,
    'inprogress': _vm.inProgress
}]},[(_vm.isLearningPathCertificate)?_c('span',{class:['certificate-crown icon-crown', { 'completed': _vm.isCourseCompleted }]}):_vm._e(),_c('span',{staticClass:"single-learningpath-item-path__circle"},[_vm._v("\n        "+_vm._s(_vm.index)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }